import { ServiceKind } from "@bitory-gmbh/bsm";
import { useBooleanFlagValue } from "@openfeature/react-sdk";
import { useFeatureAuth } from "../../auth/hooks/use-feature-auth";
import { ServiceKindList } from "@/services/backend/services/types/kinds";

/**
 * useServiceKindList returns the list of GSM service kinds
 * filtered by feature flags and the user's access rights.
 */
export function useServiceKindList(): ServiceKind[] {
  const htzReleased = useBooleanFlagValue("gsm.htz", true);
  const rltReleased = useBooleanFlagValue("gsm.rlt", true);
  const shsReleased = useBooleanFlagValue("gsm.shs", true);
  const vbsReleased = useBooleanFlagValue("gsm.vbs", true);
  const wrhReleased = useBooleanFlagValue("gsm.wrh", true);
  const htdReleased = useBooleanFlagValue("gsm.htd", true);
  const khsReleased = useBooleanFlagValue("gsm.khs", true);
  const twhReleased = useBooleanFlagValue("gsm.twh", true);
  const vdkReleased = useBooleanFlagValue("gsm.vdk", true);
  const gasReleased = useBooleanFlagValue("gsm.gas", true);
  const hqmReleased = useBooleanFlagValue("gsm.hqm", true);

  const canAccessHTZ = useFeatureAuth("gsm.htz");
  const canAccessRLT = useFeatureAuth("gsm.rlt");
  const canAccessSHS = useFeatureAuth("gsm.shs");
  const canAccessVBS = useFeatureAuth("gsm.vbs");
  const canAccessWRH = useFeatureAuth("gsm.wrh");
  const canAccessHtd = useFeatureAuth("gsm.htd");
  const canAccessKHS = useFeatureAuth("gsm.khs");
  const canAccessTWH = useFeatureAuth("gsm.twh");
  const canAccessVDK = useFeatureAuth("gsm.vdk");
  const canAccessGAS = useFeatureAuth("gsm.gas");
  const canAccessHQM = useFeatureAuth("gsm.hqm");

  return ServiceKindList.filter((kind) => {
    switch (kind) {
      case "HTZ":
        return htzReleased && canAccessHTZ;
      case "RLT":
        return rltReleased && canAccessRLT;
      case "SHS":
        return shsReleased && canAccessSHS;
      case "VBS":
        return vbsReleased && canAccessVBS;
      case "WRH":
        return wrhReleased && canAccessWRH;
      case "HTD":
        return htdReleased && canAccessHtd;
      case "KHS":
        return khsReleased && canAccessKHS;
      case "TWH":
        return twhReleased && canAccessTWH;
      case "VDK":
        return vdkReleased && canAccessVDK;
      case "GAS":
        return gasReleased && canAccessGAS;
      case "HQM":
        return hqmReleased && canAccessHQM;
      default:
        return false;
    }
  });
}
